import React from "react";
import "./Aboutproduk.scss";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import cgb from "../../Media/Foto About.webp";
const rumah = () => {
  return (
    <div id="bischofia" className="rumahjasmia">
      <h1>Welcome to Kota Harapan Indah</h1>
      <h2>Cicilan Start From 2 Juta/Bulan</h2>
      <div className="herojasmia">
        <img className="fotohome" src={cgb} alt={cgb} />
        <div className="desk-jasmia">
          Selamat Datang di Kota Harapan Indah, kawasan mandiri yang sudah
          memiliki banyak pilihan cluster siap huni. Sudah hampir 10 cluster
          siap huni, terdapat cluster Asera Nishi, Cluster Kana, Cluster
          Nismara, Cluster Albasia, Cluster Elora, Cluster Teradamai dan
          seterusnya. Dimana di setiap Cluster sudah memiliki fasilitas sendiri,
          mulai dari Clubhouse, One Gate System, Security 24 Hours. Serta sudah
          memiliki banyak tempat hiburan di dalam kawasan, Seperti HI Avenue,
          Courts, The Hive, Transera Park. Tidak lupa untuk Fasilitas Kesehatan
          dan Pendidikan, Terdapat Sekolah Saint John, BPK Penabur, Esa Unggul
          University. Untuk fasilitas Kesehatannya terdapat Eka Hospital dan
          Altius Hospital.
        </div>
      </div>
    </div>
  );
};

export default rumah;
